<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import { filter, get, orderBy } from 'lodash';
import Tile from '@/components/tile.vue';
import { BILLING_CYCLE, planTypes } from '@/common/constants';
import base from '@/views/config/addon-cards/templates/base.vue';
import addonCustomSelect from '@/plans/mx/addonCustomSelect';
import { addDefaultPbxBasePlanToShoppingCartByQuery } from '@/flows/BUY_NOW';


export default {
  name: 'ProPlusAddOnCard',
  mixins: [base, addonCustomSelect],
  components: {
    Tile,
  },
  created() {
    const { amount } = this.lowestPlan;
    this.subtitle = this.$t('billing.common.form_xx_month', [this.$money(amount)]);
    this.productPlans = this.currentProductPlans;
    //
    this.$root.$on('trigger-add-zoom-one', () => this.$emit('add'));
  },
  data() {
    return {
      title: this.$t('billing.zone_pro_plus.title'),
      subtitle: '',
      planType: planTypes.ZONE_PRO_PLUS,
      logo: require('@/assets/plans/icon_ZM.svg'),
      description: this.$t('billing.zoom_one_pro.desc'),
      form: {
        category: 'zonepropzvu',
        billingCycle: BILLING_CYCLE.ANNUAL,
        selectedNumber: 1,
      },
    };
  },
  computed: {
    ...mapState({
      planMapFlat: state => state.ShoppingCart.planMapFlat,
    }),
    ...mapGetters(['selectedPbxBasePlan']),
    currentProductPlans() {
      return orderBy(filter(this.planMapFlat, (p) => p.type === this.planType && !p.isOneMonth), ['participants', 'amount'], 'asc');
    },
    lowestPlan() {
      return get(this.currentProductPlans, [0], {});
    },
    //mixins overwrite
    // eslint-disable-next-line no-unused-vars
    addCategoryCode() {
      const { categoryCode } = this.pastPlans.find((item) => planTypes[item.semanticType] === this.planType) || {};
      if (categoryCode && this.planInfoGroupByCategory[categoryCode.toLowerCase()]) {
        return categoryCode.toLowerCase();
      }

      return 'zonepropzvu';
    },
  },
  methods: {
    ...mapMutations(['setPbxBasePlanCode','setPlanMapFlat']),
    addOn(evt) {
      // addPlanFromEnterKey For A11Y requirement
      // target is BUTTON comes from keyboard enter, will auto focaus on the first option in config card
      // target is SPAN comes from click
      const addPlanFromEnterKey = get(evt?.target, 'tagName', '') == 'BUTTON';
      if (addPlanFromEnterKey) {
        document.addPlanFromEnterKey = true;
      }
      this.updateSelectPlan({
        ...this.formPlan,
        cartInfo: {
          selected_number: this.form.selectedNumber,
        },
      });
      this.$emit('add', this.$options?.key);
      //add phone usage plan
      addDefaultPbxBasePlanToShoppingCartByQuery(this.planMapFlat);
      this.setPlanMapFlat([...this.planMapFlat]);
      if (this.selectedPbxBasePlan) {
        this.setPbxBasePlanCode(this.selectedPbxBasePlan.plan_code);
        this.savePersist()
      }
      this.$tracking.addOnBuyInteraction(`${this.trackingBasePlanName} add-ons`, `add-ons - ${this.title?.toLowerCase()} - ${this.trackingAddAction}`);
      this.$nextTick(this.focusToConfig);
    },
    mx_desc() {
      return <div class="opc-addon__description first-capitalize">
        {this.description}
      </div>;
    },
  },
};
</script>
